import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchContractFilterData = createApi('contractFilter', 'GET');

const GetContractFilter = createSlice({
  name: 'GetContractFilter',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractFilterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContractFilterData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchContractFilterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetContractFilter.reducer;